import { SalesMetroAdapters } from '../adapters';
import { SalesMetrosApi } from '../clients';

/**
 * Replaces one metro's assigned admins with `internalUserIds` and answers the
 * metro as organization-service stored it.
 *
 * @param {string} salesMetroId
 * @param {string[]} internalUserIds - The whole set; `[]` unassigns everyone.
 * @returns {Promise<import('../types/SalesMetro').ISalesMetro>}
 */
export const setSalesMetroAdmins = async (salesMetroId, internalUserIds) => {
  const response = await SalesMetrosApi.putSalesMetroAdmins(salesMetroId, internalUserIds);

  return SalesMetroAdapters.toSalesMetro(response);
};
